(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimRegistrationController',
			ClaimRegistrationController);

	ClaimRegistrationController.$inject = [ '$scope', '$state', '$log',
			'$resource', 'NgTableParams', 'ClaimRegistration', 'Upload',
			'authExpiredInterceptor', '$timeout', '$window', '$base64',
			'FileNetService', '$uibModal', '$filter', 'CommonService' ];

	function ClaimRegistrationController($scope, $state, $log, $resource,
			NgTableParams, ClaimRegistration, Upload, authExpiredInterceptor,
			$timeout, $window, $base64, FileNetService, $uibModal, $filter,
			CommonService) {

		// init all data
		var claimRegistrationCtr = this;

		claimRegistrationCtr.claimCase = {

		};

		claimRegistrationCtr.searchCompleted = false;

		claimRegistrationCtr.disableSentBtn = false;

		claimRegistrationCtr.disableAll = false;

		claimRegistrationCtr.laList = [];

		claimRegistrationCtr.agentList = [];

		claimRegistrationCtr.reasons = [];

		claimRegistrationCtr.hospitals = [];

		claimRegistrationCtr.datePickerOpenStatus = {};

		claimRegistrationCtr.documentRequireds = [];

		claimRegistrationCtr.surgeries = [];

		claimRegistrationCtr.paymentMethods = [];

		claimRegistrationCtr.policyIsTPDAndRO1 = false;
		
		claimRegistrationCtr.afterPrint = false;

		var self = $scope;

		claimRegistrationCtr.inState = function(state) {
			return $state.includes(state);
		}

		claimRegistrationCtr.init = function() {
			ClaimRegistration.getClaimPayMethod({}, function(result) {
				claimRegistrationCtr.paymentMethods = result;
			});
			
			CommonService.query({
				masterurl : 'get-all-bank-las'
			}, function(result) {
				claimRegistrationCtr.bankList = result;
			});
		}

		claimRegistrationCtr.init();

		claimRegistrationCtr.openCalendar = function(date) {
			claimRegistrationCtr.datePickerOpenStatus[date] = true;
		}
		claimRegistrationCtr.openCalendar1 = function(row) {
			row.isOpen = true;
		}

		claimRegistrationCtr.searchPolicy = function() {
			if (claimRegistrationCtr.claimCase.policyNum) {
				if( claimRegistrationCtr.claimCase.ownerIdNum == undefined ||  claimRegistrationCtr.claimCase.ownerIdNum == null)
					claimRegistrationCtr.claimCase.ownerIdNum = '';
				ClaimRegistration
						.searchPolicy(
								{
									policyNum : claimRegistrationCtr.claimCase.policyNum,
									clientIdNum : claimRegistrationCtr.claimCase.ownerIdNum
								},
								function(result) {
									console.log(result);
									if((result.needToInputIDNumber == true)
										|| (claimRegistrationCtr.claimCase.ownerIdNum != ''
											&& claimRegistrationCtr.claimCase.ownerIdNum != undefined
											&& claimRegistrationCtr.claimCase.ownerIdNum != null
											&& claimRegistrationCtr.claimCase.ownerIdNum != result.ownerIdNum
										))
									{
										document.getElementById("labelmessage").style.display = "block";
										claimRegistrationCtr.claimCase.ownerIdNum = '';
										return;
									}
									else{
										document.getElementById("labelmessage").style.display = "none";
										claimRegistrationCtr.claimCase.ownerIdNum = result.ownerIdNum;
									}
									claimRegistrationCtr.searchCompleted = true;
									claimRegistrationCtr.laList = result.las;
									claimRegistrationCtr.claimCase.agent = result.agent;
									claimRegistrationCtr.claimCase.poNum = result.poNum;
									claimRegistrationCtr.claimCase.poName = result.poName;
									claimRegistrationCtr.claimCase.payeeName = result.poName;
									claimRegistrationCtr.claimCase.idNum = result.idNum;
									claimRegistrationCtr.claimCase.poType = result.poType;
									claimRegistrationCtr.claimCase.gaRankCode = result.gaRankCode;
									claimRegistrationCtr.claimCase.gaRankDesc = result.gaRankDesc;
								});
			}

		}

		// checkSignature from kofax
		claimRegistrationCtr.checkSignature = function(policyNum) {
			if (policyNum == undefined || policyNum == null)
				return false;
			FileNetService
					.query(
							{
								method : 'get-list-poldoc',
								polNum : policyNum
							},
							function(result) {
								claimRegistrationCtr.animationsEnabled = true;
								var modalInstance =
								// show dialog
								$uibModal
										.open({
											animation : claimRegistrationCtr.animationsEnabled,
											templateUrl : GLOBAL_URL
													+ 'partial?uri=ga/signature/signature-dialog',
											controller : 'SignatureDialogController as signatureDlgCtrl',
											size : 'lg',
											resolve : {
												items : function() {
													return result;// tranfer
																	// data for
																	// dialog
												}
											}
										});
								modalInstance.result.then(function(result) {
								}, function(error) {
								});
							}, function(error) {
							});
		}
		claimRegistrationCtr.agentInfo = function() {
			if (claimRegistrationCtr.claimCase
					&& claimRegistrationCtr.claimCase.agent) {
				return claimRegistrationCtr.claimCase.agent.agentCode + " - "
						+ claimRegistrationCtr.claimCase.agent.agentName;
			}
		}

		claimRegistrationCtr.changeClaimType = function() {
			claimRegistrationCtr.claimCase.reason = null;
			claimRegistrationCtr.claimCase.claimReasonList = null;
			claimRegistrationCtr.claimCase.paymentOnSpotIndicator = false;
			ClaimRegistration.checkCanClaim({
				claimType : claimRegistrationCtr.claimCase.claimType,
				policyNum : claimRegistrationCtr.claimCase.policyNum
			}, function(result) {

			});
			ClaimRegistration.getReasons({
				claimType : claimRegistrationCtr.claimCase.claimType
			}, function(result) {
				claimRegistrationCtr.reasons = result;
			});

			if (claimRegistrationCtr.claimCase.claimType == 'MED') {
				ClaimRegistration.getSurgeries({}, function(result) {
					claimRegistrationCtr.surgeries = result;
				});

				ClaimRegistration.getHospitals({}, function(result) {
					claimRegistrationCtr.hospitals = result;
				});
			}
			;
			// reset document list
			claimRegistrationCtr.docList = [];
			claimRegistrationCtr.originalDocList = angular
					.copy(claimRegistrationCtr.docList);

			// load basic document
			ClaimRegistration.getDocumentRequireds({
				claimType : claimRegistrationCtr.claimCase.claimType
			}, function(result) {
				claimRegistrationCtr.documentRequireds = result;
				angular.forEach(result, function(document) {
					claimRegistrationCtr.docList.push({
						documentCode : document.documentCode,
						documentName : document.documentName,
						no : 0,
						receivedDate : null,
						remark : null,
						invalid : false
					});
				});
				claimRegistrationCtr.originalDocList = angular
						.copy(claimRegistrationCtr.docList);
				claimRegistrationCtr.docParams = new NgTableParams({
					count : 10000000000
				}, {
					counts : [],
					dataset : angular
							.copy(claimRegistrationCtr.originalDocList)
				});
			})
			ClaimRegistration.getDocumentByType({
				claimType : claimRegistrationCtr.claimCase.claimType
			}, function(result) {
				claimRegistrationCtr.documents = result;
			})
			// Nếu Loại bảo biểm = “Thương tật” và Loại hợp đồng là RO1 thì
			// + Tự động check vào checkbox Tai nạn
			// + Hiển thị danh sách Nguyên nhân ở dạng multiple choice để cho
			// phép user chọn nhiều nguyên nhân
			// + Enable check box “Quyền lợi cấp cứu vận chuyển” để user nhập
			// thông tin
			if (claimRegistrationCtr.claimCase.claimType == 'TPD'
					&& claimRegistrationCtr.claimCase.poType == 'RO1') {
				claimRegistrationCtr.claimCase.accidentIndicator = true;
				claimRegistrationCtr.policyIsTPDAndRO1 = true;
			} else {
				claimRegistrationCtr.claimCase.accidentIndicator = false;
				claimRegistrationCtr.policyIsTPDAndRO1 = false;
			}
		};

		claimRegistrationCtr.changeDoc = function(row) {
			if (!row.documentCode) {
				row.documentName = '';
				return;
			}
			angular.forEach(claimRegistrationCtr.documents, function(doc) {
				if (doc.documentCode == row.documentCode) {
					row.documentName = doc.documentName;
				}
			})
		}
		claimRegistrationCtr.setDocCompletedDate = function() {
			var latestDate = null;
			angular
					.forEach(
							claimRegistrationCtr.documentRequireds,
							function(documentRequired) {
								var endDate = null;
								angular
										.forEach(
												claimRegistrationCtr.originalDocList,
												function(document) {
													if (documentRequired.documentCode == document.documentCode) {
														if (document.receivedDate != null
																&& (document.invalid == null || !document.invalid)) {
															if (endDate == null
																	|| endDate < document.receivedDate) {
																endDate = document.receivedDate;
															}
														}
													}
												})
								if (endDate == null) {
									claimRegistrationCtr.claimCase.docCompletedDate = null;
									return;
								} else if (latestDate == null
										|| latestDate < endDate) {
									latestDate = endDate;
								}
							})
			claimRegistrationCtr.claimCase.docCompletedDate = latestDate;
		}

		claimRegistrationCtr.changeNoInRow = function(row) {
			if (row.receivedDate == null)
				row.receivedDate = new Date();
		};

		claimRegistrationCtr.datepickerOptions = {};

		claimRegistrationCtr.datepickerOptions.docCompletedDate = {
			maxDate : new Date()
		};

		// max date picker
		claimRegistrationCtr.datepickerOptions.eventDate = {
			maxDate : new Date()
		};

		// min date picker
		claimRegistrationCtr.datepickerOptions.hopitalStartDate = {
			minDate : null,
			maxDate : new Date()
		};

		// max date picker
		claimRegistrationCtr.datepickerOptions.hopitalEndDate = {
			minDate : null,
			maxDate : new Date()
		};

		// max date picker
		claimRegistrationCtr.datepickerOptions.receivedDate = {
			maxDate : new Date()
		};

		claimRegistrationCtr.datepickerOptions.idDate = {
			maxDate : new Date()
		};
		claimRegistrationCtr.datepickerOptions.dob = {
			maxDate : new Date()
		};

		// watch min and max dates to calculate difference
		var unwatchMinMaxValues = $scope
				.$watchCollection(
						'[claimRegistrationCtr.claimCase.hopitalStartDate, claimRegistrationCtr.claimCase.hopitalEndDate]',
						function() {
							// min max dates
							if (claimRegistrationCtr.claimCase.hopitalEndDate) {
								claimRegistrationCtr.datepickerOptions.hopitalStartDate.maxDate = claimRegistrationCtr.claimCase.hopitalEndDate;
							}
							if (claimRegistrationCtr.claimCase.hopitalStartDate) {
								claimRegistrationCtr.datepickerOptions.hopitalEndDate.minDate = claimRegistrationCtr.claimCase.hopitalStartDate;
							}
						}, true);

		// destroy watcher
		$scope.$on('$destroy', function() {
			unwatchMinMaxValues();
		});

		claimRegistrationCtr.checkDuplicateDocument = function() {
			var arrExist = [];
			var exist = false;
			angular.forEach(claimRegistrationCtr.originalDocList,
					function(doc) {
						if (arrExist.indexOf(doc.documentCode) >= 0) {
							self.addAlert('Hồ sơ [' + doc.documentName
									+ '] bị trùng. Vui lòng kiểm tra lại',
									'danger');
							exist = true;
						} else {
							arrExist.push(doc.documentCode);
						}
					});
			return exist;
		}

		claimRegistrationCtr.registration = function() {
			if (claimRegistrationCtr.checkDuplicateDocument()) {
				return;
			}
			if (claimRegistrationCtr.claimCase.claimType != 'MED') {
				claimRegistrationCtr.claimCase.policyNumClaim = null;
				claimRegistrationCtr.claimCase.bankCode = null;
				claimRegistrationCtr.claimCase.bankKhac = null;
				claimRegistrationCtr.claimCase.branchBankCode = null;
				claimRegistrationCtr.claimCase.branchBankKhac = null;
				claimRegistrationCtr.claimCase.bankAddress = null;
				claimRegistrationCtr.claimCase.differentPO = false;
				claimRegistrationCtr.claimCase.payeeName = null;
				claimRegistrationCtr.claimCase.bankAccount = null;
				claimRegistrationCtr.claimCase.dob = null;
				claimRegistrationCtr.claimCase.relationShip = null;
				claimRegistrationCtr.claimCase.bankAddress = null;
				claimRegistrationCtr.claimCase.idNum = null;
				claimRegistrationCtr.claimCase.issuingDate = null;
				claimRegistrationCtr.claimCase.authoriesId = null;
			}
			var data = [];
			claimRegistrationCtr.disableSentBtn = true;
			claimRegistrationCtr.disableAll = true;
			claimRegistrationCtr.claimCase.docList = claimRegistrationCtr.originalDocList;
			if (claimRegistrationCtr.form.file.$valid
					&& claimRegistrationCtr.attachment) {
				data['file'] = claimRegistrationCtr.attachment;
				var json = JSON.stringify(claimRegistrationCtr.claimCase);
				$log.debug(json);
				data['claimCaseDTO'] = new Blob([ json ], {
					type : "application/json"
				});
			}
			
			/*if(claimRegistrationCtr.claimCase.paymentMethod == 1) {
				claimRegistrationCtr.claimCase.paymentMethodDesc = 'Cash';
			} else if(claimRegistrationCtr.claimCase.paymentMethod == 2) {
				claimRegistrationCtr.claimCase.paymentMethodDesc = 'Cash';
			} else if(claimRegistrationCtr.claimCase.paymentMethod == 8) {
				claimRegistrationCtr.claimCase.paymentMethodDesc = 'Cash';
			}*/

			Upload
					.upload(
							{
								url : GLOBAL_URL
										+ 'api/ga/claims/registration/do-create-claim-case?access_token='
										+ authExpiredInterceptor.getToken(),
								data : data
							})
					.then(
							function(resp) {
								$log.debug('Success '
										+ resp.config.data.file.name
										+ 'uploaded. Response: ' + resp.data);
								$timeout(
										function() {
											$window
													.open(
															GLOBAL_URL
																	+ "ga/claims/gen-ack-letter/"
																	+ $base64
																			.encode(resp.data.claimCaseId)
																	+ '?access_token='
																	+ authExpiredInterceptor
																			.getToken(),
															'_blank');
										}, 3000);

							},
							function(resp) {
								$log.debug('Error status: ' + resp.status);
								$log.debug('Error status: ' + resp.status);
								if (resp.data != null
										&& resp.data[0].data == 'failure') {
									claimRegistrationCtr.disableAll = true;
									claimRegistrationCtr.disableSentBtn = true;
								} else {
									claimRegistrationCtr.disableAll = false;
									claimRegistrationCtr.disableSentBtn = false;
								}
							}, function(evt) {
								/*
								 * var progressPercentage = parseInt(100.0 *
								 * evt.loaded / evt.total);
								 * $log.debug('progress: ' + progressPercentage + '% ' +
								 * evt.config.data.file.name);
								 */
							});
		}

		claimRegistrationCtr.resetForm = function() {
			$state.transitionTo($state.current, {}, {
				reload : true,
				inherit : false,
				notify : true
			});
		}

		claimRegistrationCtr.deleteCount = 0;

		claimRegistrationCtr.documents = [];
		claimRegistrationCtr.docList = [];

		claimRegistrationCtr.originalDocList = angular
				.copy(claimRegistrationCtr.docList);

		claimRegistrationCtr.docParams = new NgTableParams({
			count : 10000000000
		}, {
			dataset : angular.copy(claimRegistrationCtr.originalDocList),
			counts : []
		});

		claimRegistrationCtr.add = function() {
			claimRegistrationCtr.isEditing = true;
			claimRegistrationCtr.isAdding = true;
			claimRegistrationCtr.docParams.settings().dataset.unshift({
				doc : {},
				no : 1,
				receivedDate : new Date(),
				remark : '',
				invalid : false
			});
			// we need to ensure the user sees the new row we've just added.
			// it seems a poor but reliable choice to remove sorting and move
			// them to the first page
			// where we know that our new item was added to
			claimRegistrationCtr.docParams.sorting({});
			claimRegistrationCtr.docParams.page(1);
			claimRegistrationCtr.docParams.reload();
		}

		claimRegistrationCtr.cancelChanges = function() {
			claimRegistrationCtr.resetTableStatus();
			var currentPage = claimRegistrationCtr.docParams.page();
			claimRegistrationCtr.docParams.settings({
				dataset : claimRegistrationCtr.originalDocList
			});
			// keep the user on the current page when we can
			if (!claimRegistrationCtr.isAdding) {
				claimRegistrationCtr.docParams.page(currentPage);
			}
		}

		claimRegistrationCtr.del = function(row) {
			_.remove(claimRegistrationCtr.docParams.settings().dataset,
					function(item) {
						return row === item;
					});
			claimRegistrationCtr.deleteCount++;
			claimRegistrationCtr.tableTracker.untrack(row);
			claimRegistrationCtr.docParams
					.reload()
					.then(
							function(data) {
								if (data.length === 0
										&& claimRegistrationCtr.docParams
												.total() > 0) {
									claimRegistrationCtr.docParams
											.page(claimRegistrationCtr.docParams
													.page() - 1);
									claimRegistrationCtr.docParams.reload();
								}
							});
		}

		claimRegistrationCtr.hasChanges = function() {
			return claimRegistrationCtr.tableForm.$dirty
					|| claimRegistrationCtr.deleteCount > 0;
		}

		claimRegistrationCtr.resetTableStatus = function() {
			claimRegistrationCtr.isEditing = false;
			claimRegistrationCtr.isAdding = false;
			claimRegistrationCtr.deleteCount = 0;
			claimRegistrationCtr.tableTracker.reset();
			claimRegistrationCtr.tableForm.$setPristine();
		}

		claimRegistrationCtr.saveChanges = function() {
			claimRegistrationCtr.resetTableStatus();
			var currentPage = claimRegistrationCtr.docParams.page();
			claimRegistrationCtr.originalDocList = claimRegistrationCtr.docParams.data;
			claimRegistrationCtr.setDocCompletedDate();
			console.log(claimRegistrationCtr.docParams);
		}
		claimRegistrationCtr.checkEventDate = function() {
			var currentDate = new Date();
			if (Number($filter('date')(
					claimRegistrationCtr.claimCase.eventDate, 'yyyyMMdd')) <= Number($filter(
					'date')(currentDate, 'yyyyMMdd'))) {
				claimRegistrationCtr.form.eventDate.$setValidity(
						'dateBiggerCurrentDate', true);
			} else {
				claimRegistrationCtr.form.eventDate.$setValidity(
						'dateBiggerCurrentDate', false);
			}
		}

		claimRegistrationCtr.checkHopitalStartDate = function() {
			if (claimRegistrationCtr.claimCase.hopitalEndDate != null
					&& Number($filter('date')(
							claimRegistrationCtr.claimCase.hopitalEndDate,
							'yyyyMMdd')) < Number($filter('date')(
							claimRegistrationCtr.claimCase.hopitalStartDate,
							'yyyyMMdd'))) {
				claimRegistrationCtr.form.hopitalStartDate.$setValidity(
						'dateBiggerHospitalEndDate', false);
			} else {
				claimRegistrationCtr.form.hopitalStartDate.$setValidity(
						'dateBiggerHospitalEndDate', true);
			}
		}

		claimRegistrationCtr.checkHopitalEndDate = function() {
			var currentDate = new Date();
			if (Number($filter('date')(
					claimRegistrationCtr.claimCase.hopitalEndDate, 'yyyyMMdd')) <= Number($filter(
					'date')(currentDate, 'yyyyMMdd'))) {
				claimRegistrationCtr.form.hopitalEndDate.$setValidity(
						'dateBiggerCurrentDate', true);
			} else {
				claimRegistrationCtr.form.hopitalEndDate.$setValidity(
						'dateBiggerCurrentDate', false);
			}
			if (claimRegistrationCtr.claimCase.hopitalStartDate != null
					&& Number($filter('date')(
							claimRegistrationCtr.claimCase.hopitalEndDate,
							'yyyyMMdd')) < Number($filter('date')(
							claimRegistrationCtr.claimCase.hopitalStartDate,
							'yyyyMMdd'))) {
				claimRegistrationCtr.form.hopitalEndDate.$setValidity(
						'dateSmallerHospitalStartDate', false);
			} else {
				claimRegistrationCtr.form.hopitalEndDate.$setValidity(
						'dateSmallerHospitalStartDate', true);
			}

		}
		claimRegistrationCtr.changeReason = function(item) {
			var reasonCode = item.claimReasonCode;
			var claimType = claimRegistrationCtr.claimCase.claimType;
			var policyNum = claimRegistrationCtr.claimCase.policyNum;
			var laNum = claimRegistrationCtr.claimCase.la.clientNum;
			if (reasonCode && claimType && policyNum && laNum) {
				ClaimRegistration
						.checkPaymentOnSpot(
								{
									reasonCode : reasonCode,
									claimType : claimType,
									policyNum : policyNum,
									laNum : laNum
								},
								function(result) {
									if (result.paymentOnSpot) {
										claimRegistrationCtr.claimCase.paymentOnSpotIndicator = true;
									}
								})
			}
		}

		claimRegistrationCtr.changePaymentMethod = function() {
			// alert(claimRegistrationCtr.claimCase.paymentMethod);
			claimRegistrationCtr.claimCase.bankCode = null;
			claimRegistrationCtr.claimCase.branchBankCode = null;
			claimRegistrationCtr.claimCase.address = null;
			claimRegistrationCtr.claimCase.dob = null;
			claimRegistrationCtr.claimCase.relationShip = null;
			claimRegistrationCtr.claimCase.differentPO = false;
			if(claimRegistrationCtr.claimCase.paymentMethod == '2A' || claimRegistrationCtr.claimCase.paymentMethod == '2B') {
				ClaimRegistration.getClaimPolicyMethod({poNum : claimRegistrationCtr.claimCase.poNum}, function(result) {
					claimRegistrationCtr.policyList = result;
				});
			}
			if(claimRegistrationCtr.claimCase.paymentMethod == '9') {
				claimRegistrationCtr.claimCase.mobile='';
				claimRegistrationCtr.claimCase.idNum='';
				claimRegistrationCtr.claimCase.payeeName='';
			}
		};

		claimRegistrationCtr.getBranchBank = function() {
			if (claimRegistrationCtr.claimCase.bankCode != undefined
					&& claimRegistrationCtr.claimCase.bankCode != null
					&& claimRegistrationCtr.claimCase.bankCode != '') {
				CommonService.query({
					masterurl : 'get-all-branch-las',
					bankCode : claimRegistrationCtr.claimCase.bankCode
				}, function(result) {
					claimRegistrationCtr.branchBankList = result;
					// var bank = {
					// 	code : "KHAC",
					// 	name : "Khác"
					// };
					// if(result != null && result.length == 0) {
					// 	claimRegistrationCtr.claimCase.branchBankCode = bank.code;
					// 	claimRegistrationCtr.claimCase.branchBankKhac = '';
					// } else {
					// 	claimRegistrationCtr.claimCase.branchBankKhac = '';
					// }
					// claimRegistrationCtr.branchBankList.push(bank);
				});
			}
		};

		claimRegistrationCtr.getBranchAddress = function() {
			if (claimRegistrationCtr.claimCase.branchBankCode != undefined
					&& claimRegistrationCtr.claimCase.branchBankCode != null
					&& claimRegistrationCtr.claimCase.branchBankCode != '') {
				CommonService
						.get(
								{
									masterurl : 'get-address-bank-branch',
									bankBranchCode : claimRegistrationCtr.claimCase.branchBankCode
								},
								function(result) {
									claimRegistrationCtr.claimCase.bankAddress = result.name;
								});
			}
		};
		
		var modalInstance = null;
		
		claimRegistrationCtr.openDialog = function() {
			modalInstance = $uibModal.open({
				animation : true,
				templateUrl : GLOBAL_URL
						+ 'partial?uri=ga/claims/registration/claim-confirm-modal',
				controller : 'ClaimDialogController',
				controllerAs : 'vm',
				size : 'md',
				backdrop: 'static'
			});
			modalInstance.result.then(function(check) {
				claimRegistrationCtr.claimCase.differentPO = check;
			}, function() {
			});
		};
		
		claimRegistrationCtr.checkDOB = function() {
			var currentDate = new Date();
			if (Number($filter('date')(
					claimRegistrationCtr.claimCase.dob, 'yyyyMMdd')) <= Number($filter(
					'date')(currentDate, 'yyyyMMdd'))) {
				claimRegistrationCtr.form.dob.$setValidity(
						'dateBiggerCurrentDate', true);
			} else {
				claimRegistrationCtr.form.dob.$setValidity(
						'dateBiggerCurrentDate', false);
			}
		}
		
		claimRegistrationCtr.doPrintClaimRequestInfo = function() {
			ClaimRegistration.download({},claimRegistrationCtr.claimCase, function(result) {
				claimRegistrationCtr.afterPrint = true;
			},function(error){
				$scope.addAlert('Vui lòng nhập đủ thông tin trước khi in phiêu yêu cầu.','danger');
			});
		};
	}
})();
